export default __webpack_public_path__ + "static/media/middleman.ca95c01e.svg";